import { Controller } from "@hotwired/stimulus"

// 複数添付を ZIP せず、各ファイルの既存ダウンロード URL を非表示 iframe で開く。
// 同一タブの遷移として順に開くと、前の遷移(S3 への 302)が終わる前に次が始まって
// 取り消されるので、ファイルごとに独立した iframe を使う。
// ブラウザが同時ダウンロードを間引くことがあるので、2件目以降は少しずらす。
// Chrome は 2件目以降で「複数ファイルの自動ダウンロード」の許可を求める。
const STAGGER_MS = 200

export default class extends Controller {
  static targets = ["file"]

  downloadAll(event) {
    event.preventDefault()
    this.removeFrames()
    this.fileTargets.forEach((link, index) => {
      const start = () => this.triggerDownload(link)
      if (index === 0) {
        start()
      } else {
        window.setTimeout(start, index * STAGGER_MS)
      }
    })
  }

  triggerDownload(link) {
    const frame = document.createElement("iframe")
    frame.hidden = true
    frame.dataset.bulkDownloadFrame = ""
    frame.src = this.downloadUrl(link)
    document.body.appendChild(frame)
  }

  removeFrames() {
    document.querySelectorAll("iframe[data-bulk-download-frame]").forEach(frame => frame.remove())
  }

  downloadUrl(link) {
    const url = new URL(link.href, window.location.origin)
    url.searchParams.set("disposition", "attachment")
    return url.toString()
  }
}
